import React, { AnchorHTMLAttributes, ReactNode } from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { SizesType } from 'types/Sizes';
import { Colors } from 'types/Theme';
import { getLinariaClassName } from '../../../utils/getLinariaClassName';
export type ButtonLinkSize = Extract<SizesType, 'sm' | 'md' | 'lg'>;
export type ButtonLinkVariant = keyof Colors['buttonLink'];
interface Props extends AnchorHTMLAttributes<HTMLAnchorElement> {
  /** Pass through className to allow styles overrides */
  className?: string;
  /** Identify the element for selection in integration tests, FullStory, etc. */
  dataId?: string;
  /** Size variant. If no size is provided, font-size inherited from surrounding text. */
  size?: ButtonLinkSize;
  /** Whether the ButtonLink should have a Default, Info, Strong or Inverse variant. */
  variant?: ButtonLinkVariant;
  /** An Icon to display on the left side of the Link for LTR languages. Inverted on RTL */
  iconStart?: ReactNode;
  /** An Icon to display on the right side of the Link for LTR languages. Inverted on RTL */
  iconEnd?: ReactNode;
  /** Whether the link should be compact or not */
  isCompact?: boolean;
  /** Whether the font-weight is bold or not */
  isBold?: boolean;
  /** Whether the underline is dotted or not */
  isDotted?: boolean;
  style?: React.CSSProperties;
}
export const ButtonLinkMinHeightMap: Record<ButtonLinkSize, number> = {
  sm: 21,
  md: 26,
  lg: 30
} as const;
export const ButtonLinkSizesMap: Record<ButtonLinkSize, number> = {
  sm: 26,
  md: 34,
  lg: 41
} as const;
const ButtonLinkWrapper = /*#__PURE__*/styled('a')({
  name: "ButtonLinkWrapper",
  class: "bzvy6c3",
  propsAsIs: false
});
const dottedUnderlineStyles = "diskhpt";
const TextWrapper = /*#__PURE__*/styled('span')({
  name: "TextWrapper",
  class: "t19d8kgs",
  propsAsIs: false
});
export const IconWrapper = /*#__PURE__*/styled('span')({
  name: "IconWrapper",
  class: "i1hds7l1",
  propsAsIs: false
});
export const ButtonLink = ({
  children,
  size = 'md',
  variant = 'default',
  isCompact = false,
  dataId = '',
  iconEnd,
  iconStart,
  className,
  isBold = true,
  isDotted = false,
  style,
  ...anchorProps
}: Props) => <ButtonLinkWrapper data-id={dataId} className={cx(`${getLinariaClassName(ButtonLinkWrapper)}--size-${size}`, `${getLinariaClassName(ButtonLinkWrapper)}--variant-${variant}`, isCompact && 'isCompact', isDotted && dottedUnderlineStyles, className)} style={style} {...anchorProps}>
    {iconStart && <IconWrapper>{iconStart}</IconWrapper>}
    <TextWrapper className={cx(`${getLinariaClassName(TextWrapper)}--size-${size}`, isBold && 'isBold')}>
      {children}
    </TextWrapper>
    {iconEnd && <IconWrapper>{iconEnd}</IconWrapper>}
  </ButtonLinkWrapper>;

require("./ButtonLink.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ButtonLink.tsx");